// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2XySc","errorLogs":"EditorFooter_errorLogs__19hDC"};